import { BlogLayout } from 'components/BlogLayout'
import { contentful } from 'utils/contentful'
import { GetStaticPaths, GetStaticProps } from 'next'
import RichTextRenderer from '../../components/marketing/RichTextRenderer'

export default function BlogPost(props) {
  const post = props.posts.blogPostCollection.items[0]
  return (
    <BlogLayout
      meta={{
        title: post.title,
        metaDescription: post.metaDescription,
        metaImage: post.metaImage.url,
        metaImageHeight: post.metaImage.height,
        metaImageWidth: post.metaImage.width,
        image: post.heroImage?.url,
        authors: post.authorsCollection.items.map((a) => a.name),
        avatars: post.authorsCollection.items.map((a) => a.avatar.url),
        twitters: post.authorsCollection.items.map((a) => a.twitterHandle),
        date: new Date(post.publishedAt),
        path: `/blog/${post.slug}`,
        bottomCtaLabel: post?.bottomCtaLabel,
        bottomCtaLink: post?.bottomCtaLink,
      }}
    >
      <RichTextRenderer data={post.body} />
    </BlogLayout>
  )
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  try {
    const json = await contentful({
      query: /* GraphQL */ `
        fragment AssetFragment on Asset {
          url
          width
          height
          title
          __typename
        }

        query getPost($slug: String!) {
          blogPostCollection(where: { slug: $slug }, limit: 1) {
            __typename
            items {
              __typename
              authorsCollection {
                __typename
                items {
                  __typename
                  twitterHandle
                  name
                  avatar {
                    ...AssetFragment
                  }
                }
              }
              title
              slug
              metaDescription
              metaImage {
                ...AssetFragment
              }
              heroImage {
                ...AssetFragment
              }
              publishedAt
              bottomCtaLabel
              bottomCtaLink
              body {
                __typename
                json
                links {
                  __typename
                  entries {
                    __typename
                    block {
                      __typename
                      sys {
                        __typename
                        id
                      }
                      ... on ComponentVideo {
                        __typename
                        url
                      }
                      ... on CodeBlock {
                        __typename
                        code
                        language
                      }
                      ... on GraphiQl {
                        __typename
                        graphQlEndpoint
                        defaultQuery
                      }
                    }
                  }
                  assets {
                    __typename
                    hyperlink {
                      ...AssetFragment
                      webpUrl: url(transform: { format: WEBP })
                      contentType
                      sys {
                        __typename
                        id
                      }
                    }
                    block {
                      ...AssetFragment
                      webpUrl: url(transform: { format: WEBP })
                      contentType
                      sys {
                        __typename
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables: {
        slug: params?.post,
      },
    })

    if (json.errors && Array.isArray(json.errors) && json.errors.length > 0) {
      throw new Error(
        `Failed to fetch blog post page: ${json.errors[0].message}`,
      )
    }

    return {
      props: {
        posts: json?.data,
      },
      revalidate: 10, // In seconds
    }
  } catch (e) {
    console.log(e)
    throw new Error('Failed to fetch blog post page')
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const json = await contentful({
    query: `query getBlogPostPaths {
      blogPostCollection {
        items {
          slug
        }
      }
    }`,
  })

  const paths = json.data.blogPostCollection.items.map((blogPost) => ({
    params: { post: blogPost.slug },
  }))

  return { paths, fallback: 'blocking' }
}
